// extracted by mini-css-extract-plugin
export default {"selectContainer":"Datalist_selectContainer__FT1xy"};